import { render, staticRenderFns } from "./SiteGroupPermission.vue?vue&type=template&id=cdb985d2&"
import script from "./SiteGroupPermission.vue?vue&type=script&lang=js&"
export * from "./SiteGroupPermission.vue?vue&type=script&lang=js&"
import style0 from "./SiteGroupPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports